import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _toastTransitionMap;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { toast, Slide, Zoom, Flip, Bounce } from 'react-toastify';
// Toastify API Docs https://fkhadra.github.io/react-toastify/api/toast/

import { BOTPRESS_ACTIONS, ToastTransitionBounce, ToastTransitionFlip, ToastTransitionSlide, ToastTransitionZoom } from './useBotpress.constants';
import { isServerSideRendering } from '../../../../utils/gatsby';
var toastTransitionMap = (_toastTransitionMap = {}, _defineProperty(_toastTransitionMap, ToastTransitionSlide, Slide), _defineProperty(_toastTransitionMap, ToastTransitionZoom, Zoom), _defineProperty(_toastTransitionMap, ToastTransitionFlip, Flip), _defineProperty(_toastTransitionMap, ToastTransitionBounce, Bounce), _toastTransitionMap);
export function dismissToast(toastId) {
  toast.dismiss(toastId);
}
export function getToastTransition(transition) {
  return toastTransitionMap[transition] || null;
}
export function createToast(content, options, messageId, callbacks) {
  var onNotificationClose = callbacks.onNotificationClose,
    addNotification = callbacks.addNotification;
  var transition = options.transition;
  var toastId = toast(content, _objectSpread(_objectSpread({}, options), {}, {
    transition: getToastTransition(transition),
    key: messageId,
    onClose: function onClose() {
      return onNotificationClose(messageId, options);
    }
  }));
  if (messageId) {
    addNotification(messageId, toastId, content);
  }
  return toastId;
}
export function actionRequiresConversation(actionType) {
  return [BOTPRESS_ACTIONS.SEND_MESSAGE, BOTPRESS_ACTIONS.SEND_EVENT].includes(actionType);
}
export function initializeBotpressState() {
  if (isServerSideRendering()) return {};
  if (!window.botpressManager) {
    window.botpressManager = {
      state: {
        notifications: new Map(),
        actionQueue: new Map(),
        checkIntervalId: null
      }
    };
  }
  return window.botpressManager.state;
}